import { motion } from 'framer-motion';
import styled from 'styled-components';
import { appearAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionWrapper = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 99999998;

  padding: 66px 44px;

  background-color: rgba(0, 0, 0, 0.5);

  overflow-y: auto;

  ${BREAKPOINTS.tablet} {
    padding: 0px;

    padding-bottom: var(--mobile-navbar-height);
  }
`;

interface ResourceSubmissionContentWrapperProps {
  showingWarning: boolean;
}

export const ResourceSubmissionContentWrapper = styled.div<ResourceSubmissionContentWrapperProps>`
  width: 100%;
  max-width: 1331px;

  display: flex;
  flex-direction: column;

  margin: 0 auto;

  background: #f7f7f7;

  border-radius: 32px;

  & > :not(:nth-child(1)),
  & > :not(:nth-child(2)) {
    z-index: 2;
  }

  ${BREAKPOINTS.tablet} {
    border-radius: 32px;
  }

  ${({ showingWarning }) =>
    showingWarning
      ? `
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
  `
      : null};

  position: relative;
`;

export const ResourceSubmissionCloseWrapper = styled.div`
  width: 100%;
  height: 84px;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  padding: 0px 40px;

  ${BREAKPOINTS.tablet} {
    border-radius: 0px;
    padding: 0px 16px;

    position: sticky;
    top: 0px;
    left: 0px;
    right: 0px;

    z-index: 1000 !important;
  }
`;

export const ResourceSubmissionCloseButton = styled.button`
  width: 55px;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;

export const ResourceSubmissionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 0 auto;

  padding: 147px 32px;

  ${BREAKPOINTS.tablet} {
    padding: 32px 16px 16px 16px;
  }
`;

export const ResourceSubmissionContentBlurBackground = styled.img.attrs({
  src: '/images/resource-submission/background-blur.jpg',
})`
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;

  border-radius: 32px 32px 0px 0px;

  ${BREAKPOINTS.tablet} {
    border-radius: 0px;
  }
`;

export const ResourceSubmissionContentNetworkBackground = styled.img.attrs({
  src: '/images/resource-submission/background-network.png',
})`
  position: absolute;
  top: 0px;
  right: 0px;
`;

// WARNING
export const ResourceSubmissionModalWarningWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px;

  background: #ffffff;
  border: none;
  border-radius: 8px;

  ${appearAnimation('1')};

  ${BREAKPOINTS.tablet} {
    right: 0px;
    left: 0px;
    transform: translate(0%, -50%);
  }
`;

export const ResourceSubmissionModalWarningButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const ResourceSubmissionModalWarningText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-text);
`;

export const ResourceSubmissionModalWarningButtonText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
`;

export const ResourceSubmissionModalWarningButton = styled.button`
  flex: 1;

  padding: 8px 16px;
  border-radius: 8px;
  background: var(--color-primary);
`;

export const ResourceSubmissionModalWarningButtonCancel = styled(
  ResourceSubmissionModalWarningButton
)`
  background: var(--color-error);
`;
